"use client"
import { useTranslations } from "next-intl"
import Link from "next/link"


const HomeBanner = () => {
  const  t  = useTranslations()
  return (
    <div className='relative flex h-[75vh] flex-col justify-center text-white'>
      <div className='flex flex-col gap-6 px-6 pt-20 sm:px-14 md:px-16'>
        <p className='text-2xl font-semibold md:text-4xl'>
          {' '} 
          {t('homePage.welcomeTo')}
        </p>
        <p className='text-4xl font-bold md:text-6xl '>Code Horizon</p>
        <p className='text-xl font-medium'>
          {t('homePage.theSourceCode')}
        </p>
        <Link
          href='/contact-us'
          className='relative z-40 w-fit rounded-md bg-white to-100% px-9 py-4 font-semibold text-secondary transition-all duration-500 hover:bg-linear-to-r hover:from-primary hover:from-50% hover:to-secondary hover:text-white'
        >
          {t('homePage.getInTouch')}
        </Link>
      </div>
    </div>
  )
}

export default HomeBanner
